var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"dialog",attrs:{"visible":_vm.isShow,"width":"40%"},on:{"close":_vm.handleClose}},[_c('YPlay',{staticClass:"dialog-video",attrs:{"videoUrl":_vm.videoUrl,"controls":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }